import settingsApi from '@/api/settings';

export default {
  state: {
    settings: {
        isShowGraph: false,
        sets: [],
        current: {},
        applied: {},
    },
    dates: [],
    compareDates: [],
    isReportLoading: false,
  },
  namespaced: true,
  mutations: {
    showGraph(state) {
      if (state.settings.isShowGraph) return;
      state.settings.isShowGraph = true;
    },
    hideGraph(state) {
      if (!state.settings.isShowGraph) return;
      state.settings.isShowGraph = false;
    },
    toggleGraph(state) {
      state.settings.isShowGraph = !state.settings.isShowGraph;
    },
    setSettings(state, settings) {
      state.settings.sets = [];
      let settingsItem;

      for(let i = 0; i < settings.length; i++) {
        const setItem = settings[i];

        try {
          settingsItem = JSON.parse(setItem.settings);
        } catch (e) {
          console.log(e.message);
          continue;
        }

        state.settings.sets.push({
          id: setItem.id,
          name: setItem.name,
          settings: settingsItem
        })
      }
    },
    setCurrentSettings(state, id) {
        state.settings.current = {};
        state.settings.current = {...state.settings.sets.find(item => item.id === id)};
    },
    setAppliedSettings(state, id) {
      state.settings.applied = {...state.settings.sets.find(item => item.id === id)};
    },
    updateAppliedSettings(state, newSettings) {
      if (state.settings.applied && state.settings.applied.settings) {
        state.settings.applied = {
          ...state.settings.applied,
          settings: {
            ...state.settings.applied.settings,
            ...newSettings
          }
        };
      }
    },
    resetSettings(state) {
      state.settings.applied = {};
      state.settings.current = {};
    },
    setDates(state, dates) {
      state.dates = dates;
    },
    setCompareDates(state, compareDates) {
      if (Array.isArray(compareDates) && compareDates.length === 2 && compareDates.every(date => typeof date === 'number')) {
        state.compareDates = compareDates;
      } else {
        state.compareDates = [];
      }
    },
    startLoading(state) {
        state.isReportLoading = true;
    },
    stopLoading(state) {
      state.isReportLoading = false;
    },
  },
  actions: {
      showGraphStore({ commit }) {
          commit('showGraph');
      },
      hideGraphStore({ commit }) {
          commit('hideGraph');
      },
      toggleGraphStore({ commit }) {
          commit('toggleGraph');
      },
      async getSettingsStore({commit}) {
          const settings = await settingsApi.getSettings();
          commit('setSettings', settings);
      },
      async getManagerSettingsIdStore({commit}) {
          return await settingsApi.getManagerSettingsId();
      },
      async setCurrentSettingsStore({commit}, id) {
          commit('setCurrentSettings', id);
      },
      async setAppliedSettingsStore({commit}, id) {
          commit('setAppliedSettings', id);
      },
      async updateAppliedSettingsStore({commit}, data) {
        commit('updateAppliedSettings', data);
      },
      async saveSettingsStore({commit}, newSettings) {

        console.log(`saveSettingsStore ${JSON.stringify(newSettings)}`);
          const settings = await settingsApi.createSettings(newSettings);
          if (!settings){
            alert('Settings could not be saved.');
            return false;
          } else {
            commit('setSettings', settings);
            return true;
          }

      },
      async updateSettingsStore({commit, dispatch}, newSettings) {
        console.log(`updateSettingsStore ${JSON.stringify(newSettings)}`);
          const settings = await settingsApi.updateSettings(newSettings);
          if (!settings){
            alert('Settings could not be saved.');
            return false;
          } else {
            commit('setSettings', settings);
            return true;
          }

      },
      async resetSettingsStore({commit}) {
          commit('resetSettings');
          await settingsApi.resetManagerSettings();
      },
      async setDatesStore({commit}, dates) {
          commit('setDates', dates);
      },
      async setCompareDatesStore({ commit }, compareDates) {
          commit('setCompareDates', compareDates);
      },
      startLoading({commit}) {
          commit('startLoading');
      },
      stopLoading({commit}) {
          commit('stopLoading');
      },
  },
  getters: {
    getIsShowGraph(state) {
      return state.settings.isShowGraph;
    },
    getSetsOfSettings(state) {
      return state.settings.sets;
    },
    getCurrentSettings(state) {
      return state.settings.current;
    },
    getAppliedSettings(state) {
      return state.settings.applied;
    },
    getDates(state) {
      return state.dates;
    },
    getCompareDates(state) {
      return state.compareDates;
    },
    getIsReportLoading(state) {
        return state.isReportLoading;
    }
  },
};
